import { defaultSalesHeaderDto, SalesHeaderDto } from "src/dtos/sales/salesBillDto";

/**
 * SAL2090_R01 - 영업 매출 내역 조회 DTO
 * 매출 헤더와 상세를 조인한 결과
 */
export interface SAL2090_R01Dto extends SalesHeaderDto {
	itemCd: string;			// 품목코드
	itemNm: string;			// 품명
	itemSpec: string;		// 규격
	modelNo: string;		// 품번
	unit: string;			// 단위 (코드)
	unitNm: string;			// 단위명
	salesQty: number;		// 수량 (BigDecimal, 소수점 5자리)
	salesPrice: number;		// 단가 (BigDecimal, 소수점 5자리)
	dcAmt: number;			// 할인액 (BigDecimal, 소수점 5자리)
	itemAmt: number;		// 금액 (BigDecimal, 소수점 5자리)
}

/**
 * 기본 데이터 (신규 행 추가시 사용)
 */
export const defaultSAL2090_R01Dto: SAL2090_R01Dto = {
	...defaultSalesHeaderDto,
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	modelNo: '',
	unit: '',
	unitNm: '',
	salesQty: 0,
	salesPrice: 0,
	dcAmt: 0,
	itemAmt: 0,
};
